export const STATUS = {
  ordered:       { label: "Ordered",       bg: "bg-emerald-50",  text: "text-emerald-800",  border: "border-emerald-200",  solid: "bg-emerald-500" },
  picking_done:  { label: "Picked",        bg: "bg-amber-50",    text: "text-amber-800",    border: "border-amber-200",    solid: "bg-amber-500" },
  scanned:       { label: "Scanned",       bg: "bg-blue-50",     text: "text-blue-800",     border: "border-blue-200",     solid: "bg-blue-500" },
  packed:        { label: "Packed",        bg: "bg-violet-50",   text: "text-violet-800",   border: "border-violet-200",   solid: "bg-violet-500" },
  dispatched:    { label: "Dispatched",    bg: "bg-slate-100",   text: "text-slate-900",    border: "border-slate-300",    solid: "bg-slate-800" },
};

export const METRIC_COLORS = {
  todays_orders:          { name: "Today's Orders",       bg: "bg-blue-50",     text: "text-blue-900",     accent: "border-blue-600",     chip: "bg-blue-600" },
  pending_picking:        { name: "Pending Picking",      bg: "bg-orange-50",   text: "text-orange-900",   accent: "border-orange-500",   chip: "bg-orange-500" },
  pending_scanning:       { name: "Pending Scanning",     bg: "bg-purple-50",   text: "text-purple-900",   accent: "border-purple-500",   chip: "bg-purple-500" },
  pending_counting:       { name: "Pending Counting",     bg: "bg-cyan-50",     text: "text-cyan-900",     accent: "border-cyan-500",     chip: "bg-cyan-500" },
  pending_packing:        { name: "Pending Packing",      bg: "bg-amber-50",    text: "text-amber-900",    accent: "border-amber-400",    chip: "bg-amber-400" },
  pending_outward:        { name: "Pending Outward",      bg: "bg-amber-100",   text: "text-amber-950",    accent: "border-amber-800",    chip: "bg-amber-800" },
  ready_dispatch:         { name: "Ready For Dispatch",   bg: "bg-green-50",    text: "text-green-900",    accent: "border-green-500",    chip: "bg-green-500" },
  todays_dispatched:      { name: "Today's Dispatched",   bg: "bg-emerald-100", text: "text-emerald-950",  accent: "border-emerald-700",  chip: "bg-emerald-700" },
  no_stock_current_month: { name: "No Stock (This Month)",bg: "bg-rose-50",     text: "text-rose-900",     accent: "border-rose-600",     chip: "bg-rose-600" },
  hold_orders:            { name: "On Hold",              bg: "bg-yellow-50",   text: "text-yellow-900",   accent: "border-yellow-500",   chip: "bg-yellow-500" },
  pending_grsr:           { name: "Pending GRSR",         bg: "bg-indigo-50",   text: "text-indigo-900",   accent: "border-indigo-500",   chip: "bg-indigo-500" },
};

export const ROLES = [
  { value: "admin",      label: "Admin" },
  { value: "accounts",   label: "Accounts" },
  { value: "salesman",   label: "Salesman" },
  { value: "picker",     label: "Picker" },
  { value: "scanner",    label: "Scanner" },
  { value: "packer",     label: "Packer" },
  { value: "collection", label: "Collection" },
];

export const roleLabel = (r) => (ROLES.find((x) => x.value === r) || {}).label || r;

const ROLE_SENIORITY = ["admin", "accounts", "picker", "scanner", "packer", "salesman", "collection", "superuser"];

/** Return the ordered list of roles for a user object or legacy string. */
export function userRoles(user) {
  if (!user) return [];
  if (Array.isArray(user.roles)) return user.roles;
  if (typeof user === "string") return [user];
  if (user.role) return [user.role];
  return [];
}

/** Primary role for display chips/avatars (most senior wins). */
export function primaryRole(user) {
  const list = userRoles(user);
  for (const r of ROLE_SENIORITY) if (list.includes(r)) return r;
  return list[0] || "";
}

/** Can this user access a feature allowed to any of `allowed`?
 *  Accepts a user OBJECT (with `.roles`), a legacy role string, or an array of roles. */
export function canAccess(userOrRole, allowed) {
  let roles = [];
  if (Array.isArray(userOrRole)) roles = userOrRole;
  else if (typeof userOrRole === "string") roles = userOrRole ? [userOrRole] : [];
  else if (userOrRole && typeof userOrRole === "object") roles = userRoles(userOrRole);
  if (!roles.length) return false;
  if (roles.includes("admin")) return true;   // admin always wins
  return allowed.some((a) => roles.includes(a));
}
